import type {
  AssetListResponse,
  PublicAsset,
  PublicTote,
  QrScan,
  ToteListResponse,
} from '@inventohub/shared';
import { ApiClientError, apiRequest } from './api';

export type QrLookup = { kind: 'tote'; tote: PublicTote } | { kind: 'asset'; asset: PublicAsset };

export async function lookupQrSlug(slug: string): Promise<QrLookup | null> {
  const toteBody = await apiRequest<ToteListResponse>(
    `/api/totes?qrSlug=${encodeURIComponent(slug)}`,
  );
  const tote = toteBody.totes[0];
  if (tote) return { kind: 'tote', tote };

  const assetBody = await apiRequest<AssetListResponse>(
    `/api/assets?qrSlug=${encodeURIComponent(slug)}`,
  );
  const asset = assetBody.assets[0];
  if (asset) return { kind: 'asset', asset };
  return null;
}

export async function lookupTypedIdentity(value: string): Promise<QrLookup | null> {
  const toteBody = await apiRequest<ToteListResponse>(
    `/api/totes?number=${encodeURIComponent(value)}`,
  );
  const tote = toteBody.totes[0];
  if (tote) return { kind: 'tote', tote };

  const assetBody = await apiRequest<AssetListResponse>(
    `/api/assets?serial=${encodeURIComponent(value)}`,
  );
  const asset = assetBody.assets[0];
  if (asset) return { kind: 'asset', asset };
  return null;
}

export async function resolveQrScan(scan: QrScan): Promise<QrLookup | null> {
  if (scan.kind === 'tote') {
    const body = await apiRequest<ToteListResponse>(
      `/api/totes?number=${encodeURIComponent(scan.number)}`,
    );
    const tote = body.totes[0];
    return tote ? { kind: 'tote', tote } : null;
  }
  if (scan.kind === 'asset') {
    const body = await apiRequest<AssetListResponse>(
      `/api/assets?serial=${encodeURIComponent(scan.serial)}`,
    );
    const asset = body.assets[0];
    return asset ? { kind: 'asset', asset } : null;
  }
  if (scan.kind === 'slug') return lookupQrSlug(scan.slug);
  return lookupTypedIdentity(scan.value);
}

export function lookupErrorMessage(error: unknown, fallback: string): string {
  return error instanceof ApiClientError ? error.message : fallback;
}
